module.exports = __webpack_public_path__ + "img/digitalIdentity12.0e4cd6d1.png";